
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
    inheritAttrs: false,
})
export default class AutoSizeTextarea extends Vue {
    @Prop({ required: false, type: String, default: null })
    public value!: string | null;

    public innerValue: string | null = '';
    public wrapperClass: string = 'autosize-wrapper';
    public textareaClass: string = '';

    public get attrs(): any {
        return {
            ...this.$attrs,
            class: this.textareaClass,
        };
    }

    public mounted(): void {
        // This is a hack to prevent the root node from inheriting the class defined on the component
        // and instead pass it along to the textarea element.
        this.textareaClass = Array.from(this.$el.classList).filter((className) => className !== this.wrapperClass).join(' ');
        this.$el.setAttribute('class', this.wrapperClass);
    }

    public onBlur(): void {
        this.$emit('blur');
    }

    @Watch('value', { immediate: true })
    public onValueChanged(value: string | null): void {
        this.innerValue = value;
    }

    @Watch('innerValue')
    public onInnerValueChanged(value: string | null): void {
        if (this.innerValue !== this.value) {
            this.$emit('input', value);
            this.$emit('change');
        }
    }
}
